class EffectAdapter {
  constructor(setValue) {
    this.setValue = setValue;
  }

  connect() {}

  disconnect() {}

  update(config) {
    this.setValue(config);
  }
}

export { EffectAdapter };
